import { BASE_URL, ERRORS } from "./constantes";

const readUrl = (url, params = {}) => {
    let parameters = Object.entries(params).map(([key, value]) => {
        return `${key}=${value}&`
    }).join().replaceAll('&,', '&')
    const uri_path = url.startsWith('http') || url.startsWith('https') ? url : `${BASE_URL}${url}`
    const current_url = (parameters.length > 0) ? `${uri_path}?${parameters}` : uri_path
    return current_url
}

const getHeaderToken = (token) => { return { 'Authorization': `Bearer ${token}` } }

async function raiseError(err) {
    if (err.status === 401) {
        alert('Acceso no autorizado')
        window.location.href = '/';
    } else {
        if (err.body) {
            const data = await err.json();
            const { error } = data;
            let message = data.message;
            if (error) {
                const code = error.code || 'X';
                message = `${code}: ${error.message}`;
                if (ERRORS[code])
                    message = ERRORS[code];
            }
            throw message;
        }
        throw err;
    }
}
/**
 * 
 * @param {string} url 
 * @param {object} data 
 * @returns 
 */
const post = (url, data, headers = {}) => {
    try {
        return fetch(readUrl(url), {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                ...headers
            },
            body: JSON.stringify({ ...data })
        })
            .then(res => {
                if (!res.ok) {
                    throw res
                }
                return res;
            })
            .then(res => {
                return res.json();
            })
            .catch(async err => {
                await raiseError(err);
            });
    } catch (error) {
        console.log(JSON.stringify(error));
    }
}
const get = (url, headers = {}, params) => {
    try {
        const current_url = readUrl(url, params)
        return fetch(current_url, {
            method: "GET",
            headers: {
                "Content-Type": "application/json",
                ...headers
            },
        })
            .then(res => {
                if (!res.ok) {
                    throw res
                }
                return res;
            })
            .then(res => {
                return res.json();
            })
            .catch(async (err) => {
                await raiseError(err);
            })
    } catch (error) {
        console.log(JSON.stringify(error));
    }
}
const patch = ({ url, data, headers = {} }) => {

    try {
        return fetch(readUrl(url), {
            method: "PATCH",
            headers: {
                "Content-Type": "application/json",
                ...headers
            },
            body: JSON.stringify({ ...data }),
        })
            .then(res => {
                if (!res.ok) {
                    throw res
                }
                return res;
            })
            .then(res => {
                return res.json();
            })
            .catch(async err => {
                await raiseError(err);
            });
    } catch (error) {
        console.log(JSON.stringify(error));
    }
}
const remove = (url, headers = {}) => {
    try {
        return fetch(readUrl(url), {
            method: "DELETE",
            headers: {
                "Content-Type": "application/json",
                ...headers
            }
        })
            .then(res => {
                if (!res.ok) {
                    throw res
                }
                return res;
            })
            .then(res => {
                return res.json();
            })
            .catch(async err => {
                await raiseError(err);
            });
    } catch (error) {
        console.log(JSON.stringify(error));
    }
}

const download = (url, headers = {}, params) => {
    try {
        return fetch(url, {
            method: "GET",
            headers: {
                "Content-Type": "application/json",
                ...headers
            },
        })
            .then(response => response.blob())
            .then(blob => {
                var url = window.URL.createObjectURL(blob);
                var a = document.createElement('a');
                a.href = url;
                a.download = params.id + ".zip";
                document.body.appendChild(a); // we need to append the element to the dom -> otherwise it will not work in firefox
                a.click();
                a.remove();  //afterwards we remove the element again         
            })
            .catch(async (err) => {
                await raiseError(err);
            })
    } catch (error) {
        console.log(JSON.stringify(error));
    }
}

export const getFilter = (url, token) => {
    return get(readUrl(url, getHeaderToken(token)))
}

export const AuthRegister = (user) => {
    const userData = {
        "email": user.email,
        "password": user.password,
        "name": user.username,
    }
    return post(`/auth/users`, userData)
}

export const AuthLogin = (data) => {
    return post('/auth/users/login', data)
}

/**
 * Roles
 */
export const listRol = (token) => {
    return Promise.resolve(["DEFAULT", "VENDEDOR", "LIDER", "ADMIN"])
}

/**
 * Marketplace
 */
export const listMarketplace = (token) => {
    return get(
        readUrl(`/marketplaces`),
        getHeaderToken(token)
    )
}

export const listUsersByMarketplace = (marketplace_id, token) => {
    return get(
        readUrl(`/marketplaces/${marketplace_id}/users`),
        getHeaderToken(token)
    )
}

export const storeMarketplace = (marketplace, token) => {
    return post(
        readUrl(`/marketplaces`),
        marketplace,
        getHeaderToken(token)
    )
}

export const updateMarketplace = (marketplace, token) => {
    return patch({
        url: readUrl(`/marketplaces/${marketplace._id}`),
        data: { ...marketplace, _id: undefined },
        headers: getHeaderToken(token)
    })
}

export const getMarketplace = (id, token) => {
    return get(
        readUrl(`/marketplaces/${id}`),
        getHeaderToken(token)
    )
}

/**
 * usuarios
 */
export const listUsuario = ({ token, params }) => {
    return get(
        readUrl(`/auth/users`, params),
        { 'Authorization': `Bearer ${token}` }
    )
}

export const updateUsuario = (usuario, token) => {
    return patch({
        url: `/auth/users/${usuario.id}`,
        headers: { 'Authorization': `Bearer ${token}` },
        data: {
            name: usuario.name,
            blocked: usuario.blocked,
            rol: usuario.rol,
            marketplace: usuario.marketplace
        }
    })
}

export const getUsuario = (id, token) => {
    return get(
        readUrl(`/auth/users/${id}`),
        { 'Authorization': `Bearer ${token}` }
    )
}

/**
 * Lotteries
 */
export const listLottery = ({ token, params = {} }) => {
    return get(
        readUrl(`/lotteries`, params),
        getHeaderToken(token)
    )
}

export const storeLottery = (marketplace, token) => {
    return post(
        readUrl(`/lotteries`),
        marketplace,
        getHeaderToken(token)
    )
}

export const updateLottery = (marketplace, token) => {
    return patch({
        url: readUrl(`/lotteries/${marketplace._id}`),
        data: { ...marketplace, _id: undefined },
        headers: getHeaderToken(token)
    })
}

export const getLottery = (id, token) => {
    return get(
        readUrl(`/lotteries/${id}`),
        getHeaderToken(token)
    )
}

export const deleteLottery = (id, token) => {
    return remove(
        readUrl(`/lotteries/${id}`),
        getHeaderToken(token)
    )
}

/**
 * Tickets
 */
export const listTicket = ({ token, params }) => {
    return get(
        readUrl(`/tickets`, params),
        getHeaderToken(token)
    )
}

export const storeTicket = (marketplace, token) => {
    return post(
        readUrl(`/tickets`),
        marketplace,
        getHeaderToken(token)
    )
}

export const updateTicket = (marketplace, token) => {
    return patch({
        url: readUrl(`/tickets/${marketplace._id}`),
        data: { ...marketplace, _id: undefined },
        headers: getHeaderToken(token)
    })
}

export const getTicket = (id, token) => {
    return get(
        readUrl(`/tickets/${id}`),
        getHeaderToken(token)
    )
}

export const findTicket = ({ token, params }) => {
    const { code } = params
    return get(
        readUrl(`/tickets/${code}/marketplaces/lotteries`),
        getHeaderToken(token)
    )
}

export const deleteTicket = (id, token) => {
    return remove(
        readUrl(`/tickets/${id}`),
        getHeaderToken(token)
    )
}

/**
 * Rewards
 */
export const listReward = ({ token, params }) => {
    return get(
        readUrl(`/rewards`, params),
        getHeaderToken(token)
    )
}

export const storeReward = (marketplace, token) => {
    return post(
        readUrl(`/rewards`),
        marketplace,
        getHeaderToken(token)
    )
}

export const updateReward = (marketplace, token) => {
    return patch({
        url: readUrl(`/rewards/${marketplace._id}`),
        data: { ...marketplace, _id: undefined },
        headers: getHeaderToken(token)
    })
}

export const getReward = (id, token) => {
    return get(
        readUrl(`/rewards/${id}`),
        getHeaderToken(token)
    )
}

export const deleteReward = (id, token) => {
    return remove(
        readUrl(`/rewards/${id}`),
        getHeaderToken(token)
    )
}

export const listGenerator = ({ token, params }) => {

    return get(
        readUrl(`/generators`, params),
        getHeaderToken(token)
    )
}

export const getGenerator = ({ token, params }) => {

    return get(
        readUrl(`/generators/${params.id}`,),
        getHeaderToken(token)
    )
}

export const getGeneratorDetails = ({ token, params }) => {
    return get(
        readUrl(`/generators/${params.id}/details/${params.number}`),
        getHeaderToken(token)
    )
}

export const storeGenerator = (generator, token) => {
    return post(
        readUrl(`/generators`),
        generator,
        getHeaderToken(token)
    )
}

export const deleteGenerator = (id, token) => {
    return remove(
        readUrl(`/generators/${id}`),
        getHeaderToken(token)
    )
}

export const generatroPDF = ({ id, color, token }) => {
    return download(
        readUrl(`/generators/${id}/pdf`, { color }),
        getHeaderToken(token),
        { id, color, token }
    )
}